import Vue from 'vue'
import VueIdb from 'vue-idb'
import './pollyfills'
import VueRouter from 'vue-router'
import VueNotify from 'vue-notifyjs'
// import VeeValidate from 'vee-validate'
// import lang from 'element-ui/lib/locale/lang/en'
// import locale from 'element-ui/lib/locale'
import App from './App.vue'

// Plugins
import GlobalComponents from './gloablComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'

// router setup
import routes from './routes/routes'

// library imports

import './assets/sass/paper-dashboard.scss'
import './assets/sass/element_variables.scss'
import './assets/sass/demo.scss'

import sidebarLinks from './sidebarLinks'
// plugin setup
Vue.use(VueIdb)
Vue.use(VueRouter)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, {sidebarLinks: sidebarLinks})
// Vue.use(VeeValidate)
// locale.use(lang)

window.dibutor = 5

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active'
})

export default new VueIdb({
  version: 4,
  database: 'webzakaz',
  schemas: [
    { goods: '++, id, price, name, isgroup, parent, islevel, unitname, photo, v3, distr' },
    // eslint-disable-next-line standard/object-curly-even-spacing
    { order: 'good, quantity, price, name, photo, unit, dsum, multiplier, discount, project, info, distr'},
    // eslint-disable-next-line standard/object-curly-even-spacing
    { orders: '++id, uuid, goods, sum, dt, status, info, distr'},
    // eslint-disable-next-line standard/object-curly-even-spacing
    { settings: 'token, dbase, regcode, lastconnection, inn, phone, address, info, сurent_dst, client_extid, firm_name'},
    {distributors: '++id, name, token, dbase, regcode'}
  ]
})

// db.on('versionchange', function(event) {
//   console.log('++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++')
// })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router
})



// WEBPACK FOOTER //
// ./src/main.js